export function analyticsInitializer() {
  const env = (window as any).__env__ || {};
  const analyticsEnabled = env.analyticsEnabled !== false && env.analyticsEnabled !== 'false';
  const src: string = env.analyticsScript;

  if (!analyticsEnabled || !src) {
    return;
  }

  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }

  const script: HTMLScriptElement = document.createElement('script');

  script.setAttribute('src', src);
  script.async = true;
  document.head.appendChild(script);
}
